import { ConfigProvider } from "antd";
import { FC, PropsWithChildren } from "react";

export const Theme: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Tabs: {
            itemColor: "#384853",
            itemHoverColor: "#11643C",
            itemSelectedColor: "#11643C",
            inkBarColor: "#11643C",
            itemActiveColor: "#11643C",
            lineWidthFocus: 6,
            titleFontSizeLG: 16
          },
          Divider: {
            colorSplit: '#8DC467',
            margin: 0,
            marginLG: 3,
            lineWidth: 2,
          },
          Form: {
            itemMarginBottom: 10,
            fontFamily: 'BRFirma-Medium', 
          },
          Checkbox: {
            colorBorder: '#11643C',
            colorPrimary: '#11643C',
            colorPrimaryHover: '#11643C',
            colorBgContainer: '#ffffff',
            colorText: '#5F6063',
            fontFamily: 'BRFirma-Medium', 
          },
          Table: {
            borderColor: '#E5E6E6',
            headerBg: '#E9FBF3',
            headerBorderRadius: 0,
            cellPaddingInline: 20,
            cellPaddingBlock: 10,
            footerBg: '#11643C',
            footerColor: "#011602",
            fontFamily: 'BRFirma-Medium', 
          },
          Modal: {
            paddingLG: 0,
          },
          Radio:{
            buttonSolidCheckedActiveBg: "#11643C",
            buttonSolidCheckedBg: "#11643C",
            colorPrimary: "#11643C",
          },
          Card: {
            borderRadiusLG: 20,
          },
          Steps:{
            colorPrimary:"#68B859",
            colorPrimaryBorder: "#68B859",
            fontFamily: 'BRFirma-Medium'
          },
          Spin: {
            colorPrimary: '#8dc467',
          }
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};


